import { ThemeProvider as StyledComponentsThemeProvider } from 'styled-components';
import CurrentLightTheme from 'foundations-theming/themes/current/light/theme';
import { jsx as _jsx } from "react/jsx-runtime";
export const AppProvider = ({
  // themeName = 'current',
  // themeMode = 'light',
  children
}) => {
  // In a follow-up PR, we can add support to load themes dynamically instead.
  // E.g. https://git.hubteam.com/errodriguez/hds-components-prototypes/blob/master/src/theming-experiment/ExperimentalAppProvider.tsx#L37-L46

  return /*#__PURE__*/_jsx(StyledComponentsThemeProvider, {
    theme: CurrentLightTheme,
    children: children
  });
};